import { type JSX } from 'react';

import { TextEllipsis } from '@dynatrace/strato-components/typography';

import { valueContent } from './HiveTooltipItem.sty.js';
import {
  SeriesItemProps,
  Variant,
} from '../../../core/components/tooltip/ChartTooltip/components/SeriesItem/SeriesItem.js';
import { TooltipText } from '../../../core/components/tooltip/section-components/atoms/TooltipText.js';
import { TooltipInfoContent } from '../../../core/components/tooltip/section-components/TooltipInfoContent/TooltipInfoContent.js';
import { TooltipItem } from '../../../core/components/tooltip/section-components/TooltipItem/TooltipItem.js';
import { TooltipSymbolContent } from '../../../core/components/tooltip/section-components/TooltipSymbolContent/TooltipSymbolContent.js';
import { TooltipValueContent } from '../../../core/components/tooltip/section-components/TooltipValueContent/TooltipValueContent.js';
import { BubbleShape } from '../../../core/components/tooltip-atoms/shapes/BubbleShape/BubbleShape.js';
import { MultiDataPointShape } from '../../../core/components/tooltip-atoms/shapes/MultiDataPointShape.js';
import { SingleDataPointShape } from '../../../core/components/tooltip-atoms/shapes/SingleDataPointShape.js';
import { DEFAULT_TRUNCATION_MODE } from '../../../core/constants.js';

export const HiveTooltipItem = (props: SeriesItemProps) => {
  const {
    color,
    name,
    value,
    variant = 'single',
    actions,
    truncationMode = DEFAULT_TRUNCATION_MODE,
  } = props;
  const SYMBOL: Record<Variant, JSX.Element> = {
    single: <SingleDataPointShape color={color} />,
    multi: <MultiDataPointShape color={color} />,
    bubble: <BubbleShape color={color} />,
  };

  return (
    <TooltipItem actions={actions}>
      <TooltipSymbolContent>{SYMBOL[variant] ?? null}</TooltipSymbolContent>
      <TooltipInfoContent>
        <TooltipText truncationMode={truncationMode}>{name}</TooltipText>
      </TooltipInfoContent>
      {!!value && (
        <TooltipValueContent variant="chip" className={valueContent}>
          <TextEllipsis
            truncationMode={truncationMode}
            aria-label="Value serie name"
          >
            {value as string}
          </TextEllipsis>
        </TooltipValueContent>
      )}
    </TooltipItem>
  );
};

HiveTooltipItem['displayName'] = 'HiveTooltipItem';
